<b class="subtitle">Numéro ADEME du DPE <span class="text-muted">(obligatoire)</span></b>
<input type="text" class="form-control mt-2" placeholder="Ex : 2380E1234567W"
       [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [readonly]="readonly">

<ng-content></ng-content>

<div class="info-box mt-3 mb-3">
    <i class="fa fa-lightbulb-o"></i>
    <span>
        Le numéro ADEME est l'identifiant unique du DPE (13 caractères).
        Il figure sur la première page du diagnostic, dans le cadre « N° ADEME » situé en haut à droite,
        et il est repris sur l'attestation remise par le diagnostiqueur.
    </span>
</div>
<a href="assets/numero-ademe.jpg" target="_blank" rel="noopener" class="hide-mobile" *ngIf="showImage">
    <img src="assets/numero-ademe.jpg" class="ademe-help"
         alt="Emplacement du numéro ADEME sur la première page du DPE"/>
</a>
